import React from "react";

import NextImage from "../common/NextImage";

const CricketTable = ({ data }) => {
  return data?.fallOfWickets?.map((player, index) => (
    <tr key={index}>
      <td>{player?.bl} Ov</td>
      <td>
        <div className="bolar_team">
          <div className="ico_flag">
            <NextImage
              src={`https://cric.livescoring.cc/teamflags/${player?.tid}.png`}
              width={22}
              height={22}
              key={player?.tid}
            />
          </div>
          <span className="name">{player?.batsman?.nm}</span>
        </div>
        <span className="bow_inf">b {player?.bowler?.nm}</span>
      </td>
      {/* <td>b {player?.bowler?.nm}</td> */}
      <td>{player?.ft}</td>
    </tr>
  ));
};

export default CricketTable;
